import { Categories } from 'shared/custom/hooks/Categories';

/**
 *
 * Find up the parent category names for a given catalogGroupId.
 * Use this to get category names for Google Analytics tracking.
 *
 * Usage:
 *  Use hook to get category top level data, then pass along with this product's parentCatalogGroupID to get names.
 *  parentCatalogGroupID is a string like "/10003/10552/50508".
 *  Their labels will be returned as an array of strings.
 * Example:
 * const { navigation } = useGetCategories();
 * const getCategoryLabels = findParentCategories(navigation, product?.parentCatalogGroupID);
 *
 * @param data - The categories data from useGetCategories hook.
 * @param catalogGroupId - The product's parentCatalogGroupID string or array.
 */
export const findParentCategories = (
	data: Categories[],
	catalogGroupId: string | string[]
): string[] => {
	let catalogGroupIdArr: string[];
	const catalogGroupIdStr = Array.isArray(catalogGroupId) ?
		(catalogGroupIdArr = catalogGroupId.filter((item) => item.split("/").length === 4),
			catalogGroupIdArr?.length > 0 ?	catalogGroupIdArr[0] : catalogGroupId[0])
		: catalogGroupId;

	const findCategoryLabelById = (nodes: Categories[], id: string): string | null =>
		nodes.reduce<string | null>((found, node) => {
			if (found) return found;
			if (node.uniqueID === id || node.id === id) return node.label;
			return findCategoryLabelById(node.children ?? [], id);
		}, null);

	return catalogGroupIdStr
		?.split('/')
		.map((id: string) => findCategoryLabelById(data, id))
		.filter((label: string | null): label is string => label !== null);
};
